/**
 * Assigns a 0-based `order` matching array position.
 * Canonical sort key for editable collection grids.
 */
export function assignCollectionOrder<T>(items: T[]): (T & { order: number })[] {
	return items.map((item, index) => ({ ...item, order: index }))
}

/** Immer-friendly: mutates draft rows in place. */
export function renumberOrderInPlace(draft: { order?: number }[]): void {
	draft.forEach((item, index) => {
		item.order = index
	})
}
